import { useMemo } from 'react';
import { InstagramCreator, InstagramCreatorPost } from '@frontend/gql/social/graphql';

export interface CreatorPostsGridProps {
  username?: string;
  recentPosts: InstagramCreatorPost[];
  isLoading: boolean;
  maxPosts?: number;
}

export const useCreatorPostsGridProps = (
  creator: InstagramCreator | null,
  isLoading: boolean,
  maxPosts: number = 9,
): CreatorPostsGridProps => {
  const recentPosts = useMemo(() => {
    if (!creator || !Array.isArray(creator.recentPosts)) {
      return [];
    }
    return creator.recentPosts.slice(0, maxPosts);
  }, [creator, maxPosts]);

  return {
    username: creator?.username,
    recentPosts,
    isLoading,
    maxPosts,
  };
};
